import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { customerDetailsStrings } from '../../data/static/strings'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

export interface CustomerDetailsObj {
  id: string
  name: string
  mobileNumber: string
  email: string
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  zipCode: string
}

interface CustomerDetailsProps {
  customer: CustomerDetailsObj
}
const CustomerDetails: FC<CustomerDetailsProps> = ({ customer }: CustomerDetailsProps) => {
  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)
  return (
    <Box {...themes.detailsContainer}>
      <TextNew type="titleBold16">{customerDetailsStrings.labelCustomerDetails}</TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsContent}>
          <Box {...themes.detailsSubContainer}>
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelCustomerId}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelCustomerName}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelAddressLine1}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelCity}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelZipCode}
            </TextNew>
          </Box>
          <Box {...themes.detailsSubContainer}>
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.id}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.name}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.addressLine1}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.city}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.zipCode}
            </TextNew>
          </Box>
        </Box>
        <Box {...themes.divider} />
        <Box {...themes.detailsSideContainer}>
          <Box {...themes.detailsSubContainer}>
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelMobileNumber}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelEmail}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelAddressLine2}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="bold">
              {customerDetailsStrings.labelState}
            </TextNew>
          </Box>
          <Box {...themes.detailsSubContainer}>
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.mobileNumber}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.email}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.addressLine2}
            </TextNew>
            <Spacer size={8} />
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {customer?.state}
            </TextNew>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CustomerDetails
